// extracted by mini-css-extract-plugin
module.exports = {"alert":"alert_alert__216f0"};